import {Component, Input} from '@angular/core';
import {Group} from "@icure/api";
import {CodeImportationDialogComponent} from "../dialogs/code-importation-dialog/code-importation-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {
  TemplateImportationDialogComponent
} from "../dialogs/template-importation-dialog/template-importation-dialog.component";


@Component({
  selector: 'ms-database-group-info-tools',
  templateUrl: './database-group-info-tools.component.html',
  styleUrl: './database-group-info-tools.component.scss',
  standalone: false
})
export class DatabaseGroupInfoToolsComponent {
  @Input() selectedGroup: Group = {};

  public displayedColumns: string[] = ['description', 'btn'];
  public tools: { id: string; description: string; }[] = [{
    id: 'codeUpload',
    description: "Uploader les codes dans la base de données"
  },
    {
      id: 'formTemplateUpload',
      description: "Uploader les templates de formulaire dans la base de données"
    }];

  constructor(
    private dialog: MatDialog,
  ) {

  }

  public launchTool(e: Event) {
    console.log(e);
    // @ts-ignore
    if (e.id === 'codeUpload') {
      const codeImportationDialog = this.dialog.open(CodeImportationDialogComponent, {
        data: {toolType: e, selectedGroup: this.selectedGroup},
        height: '700px',
        width: '1000px'
      });
      //@ts-ignore
    } else if (e.id === 'formTemplateUpload') {
      const templateImportationDialog = this.dialog.open(TemplateImportationDialogComponent, {
        data: {toolType: e, selectedGroup: this.selectedGroup},
        height: '700px',
        width: '1000px'
      });
    }
  }
}
